import {
  MutationCache,
  QueryClient as ReactQueryQueryClient,
} from "@tanstack/react-query";
import { toast } from "sonner";
import { NetworkError } from "@/lib/GraphQLCodegen/fetcher";

/**
 * The max age for any of our cached data
 */
export const QueryClient = new ReactQueryQueryClient({
  mutationCache: new MutationCache({
    onError: (e, _variables, _context, mutation) => {
      // Skip global toast if the mutation has its own onError handler
      if (mutation.options.onError) return;

      if (e instanceof NetworkError) {
        toast.error("Network error", {
          description:
            "Unable to reach the server. Please check your connection and try again.",
        });
        return;
      }

      const message =
        "response" in e
          ? (e.response as { errors?: { message: string }[] })?.errors?.at(0)
              ?.message
          : e.message;

      toast.error("An error occurred", { description: message });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
    },
    mutations: {
      onSuccess: (_1, _2, _3, context) => {
        context.client.invalidateQueries({
          predicate: (query) => {
            const [key] = query.queryKey as [string, string];
            const whiteList = ["__BUILD__"];
            return !whiteList.includes(key);
          },
        });
      },
    },
  },
});
